import React, { useEffect, useContext, useState } from 'react';
import { ThemeContext } from "../../Layout/Theme/ThemeContext";
import { useNavigate } from 'react-router-dom';
import FormPermissionService from "../../Setup/controller/FormPermissionController/FormPermissionController";
import CreateOpportunityPage from './OpportunityForms/CreateOpportunity';
import CommunicationHistoryPage from './OpportunityForms/CommunicationHistory';
import Draggable from 'react-draggable';
import OppurtunityService from "../Controller/OppurtunityController";
import QuotationListPage from "../../Quotation/View/QuotationList";
import OpportunityDocumentListPage from "./OpportunityForms/OpportunityDocumentList";
import OpportunityUserDefineFields from "./OpportunityForms/OpportunityUserDefineFields";
import OpportunityReportPage from "./OpportunityForms/OpportunityReport";
import ModuleService from "../../Setup/controller/ModuleController/ModuleController";
import HelpSite from "../../Common/HelpLink";
const MODULE_IDS = {
    Assets: 3,
    Parts: 4,
    Suppliers: 5,
    Quotations: 6,
    SalesOrders: 7,
    Purchasing: 8,
    Agreements: 9,
    Jobs: 10,
    Contacts: 15,
};


function OppurtunityDetail({ OpportunityID, onClose, onSuccess, IsDiaries, CommunicationID, onNext, onPrevious, IsCustomerSelection }) {
    const navigate = useNavigate();
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const RoleID = localStorage.getItem('RoleID');
    const FormAction = "/AdministrationSetting";
    //FormPermissionService.HasPerimssion(redirectCallback, RoleID, FormAction);
    const { theme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }

    const [isMinimized, setIsMinimized] = useState(false);
    const [OpportunityIDName, setOpportunityIDName] = useState("Lead Details");
    const [activeTab, setActiveTab] = useState(IsDiaries === "1" ? 'tab-Oppcomm' : 'tab-Oppurtunity');
    const [currentOpportunityID, setCurrentOpportunityID] = useState(OpportunityID);
    const [tabCount, setTabCount] = useState(0);
    const [isLock, setIsLock] = useState(0);
    const UserID = localStorage.getItem("UserID");
    const [Email, setEmail] = useState();
    const [phone, setPhone] = useState();
    const [mobile, setMobile] = useState();
    const [companyName, setCompany] = useState();
    const [assignedModules, setAssignedModules] = useState(new Set());
    const toggleMinimize = () => {
        setIsMinimized(!isMinimized);
    };
    useEffect(() => {
        setCurrentOpportunityID(OpportunityID);
        setActiveTab(IsDiaries === "1" ? 'tab-Oppcomm' : 'tab-Oppurtunity');
        fetchAssignedModules();
        if (OpportunityID > 0) {

            fetchOppurtunityDetail(OpportunityID);


        } else {
            setOpportunityIDName("Opportunity Details");
        }

    }, [OpportunityID]);
    const fetchOppurtunityDetail = async (newOpportunityID) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const LeadDetail = await OppurtunityService.GetOppurtunityByID(redirectCallback, newOpportunityID);
            setOpportunityIDName(LeadDetail[0].vc_Company); // Update this line to match your data structure
            setPhone(LeadDetail[0].vc_Phone);
            setMobile(LeadDetail[0].vc_Mobile);
            setCompany(LeadDetail[0].vc_Company);
            setEmail(LeadDetail[0].vc_Email)
            if (LeadDetail[0].isLock === 1 && LeadDetail[0].LockBy != UserID) {
                setIsLock(1);
            }
            else {
                setIsLock(0);
                await OppurtunityService.LockOpportunity(newOpportunityID);
            }



        } catch (error) {
            console.error('Error fetching asset details:', error);
        }
    };
    const handleSuccess = async () => {
        const newLeadID = parseInt(localStorage.getItem('OpportunityID'), 10);
        setCurrentOpportunityID(newLeadID);
        await fetchOppurtunityDetail(newLeadID);
    };
    const changeTab = (tab) => {
        setActiveTab(tab);
        handleTabClick(); // Increment count
    };
    const handleTabClick = () => {
        setTabCount(prevCount => prevCount + 1); // Increment the count when any tab is clicked
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    const CompanyID = localStorage.getItem("CompanyID");
    const fetchAssignedModules = async () => {
        try {
            const modules = await ModuleService.GetRoleModules(redirectCallback, "en", CompanyID);
            const moduleSet = new Set(modules.map(m => m.PK_SearchModule_ID)); // Store assigned module IDs in a Set
            setAssignedModules(moduleSet);
        } catch (error) {
            console.error('Error fetching assigned modules:', error);
        }
    };
    let tabClass = (currentOpportunityID > 0) ? "nav-link" : "nav-link disabled";
    return (
        <div className="modal fade oppurtunityDetailModal show d-block" id="oppurtunityDetailModal" tabIndex="-1" aria-labelledby="leadDetailModalLabel" aria-hidden="true" data-backdrop="static">
            <div className={`modal-dialog ${IsCustomerSelection === "1" ? 'modal-lg' : 'modal-xl'}`}>
                <Draggable handle=".modal-header" onStart={handleStart}
                    cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p"
                    bounds={{ top: 0, bottom: window.innerHeight - 400 }}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{OpportunityIDName && OpportunityIDName.length > 20
                                ? `${OpportunityIDName.substring(0, 20)}...`
                                : OpportunityIDName} <strong style={{ fontSize: "14px", color: "red" }}> {isLock.toString() === "0" ? "" : "(Locked)"}</strong></h5>
                            <span>
                                <button type="button" className="close" onClick={onClose} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <button type="button" className="close" onClick={toggleMinimize} aria-label="Minimize">
                                    <span aria-hidden="true">{isMinimized ? '+' : '-'}</span>
                                </button>

                            </span>
                        </div>
                        {!isMinimized && (
                            <div className="modal-body" style={{ flex: "1" }}>
                                <div className="row vertical-pills-tab">
                                    <div className="d-flex justify-content-between align-items-center" style={{ marginLeft: "20px", marginRight: "25px", width: "100%", background: "#fff", borderBottom: "1px solid #d8e0e3" }}>
                                        <ul className="nav nav-tabs" style={{ border: "none", borderColor: "none" }}>
                                            <li className="nav-item">
                                                <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-Oppurtunity' ? 'active' : ''}`} data-toggle="pill" href="#tab-Oppurtunity" onClick={() => changeTab('tab-Oppurtunity')} >
                                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                        <img src="assets/img/resources/opp_details.png" style={{ width: "25px", height: "25px" }} />
                                                        <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Details</strong>
                                                    </div>
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                {isLock.toString() === "0" ? (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-Oppcomm' ? 'active' : ''}`} data-toggle="pill" href="#tab-Oppcomm" onClick={() => changeTab('tab-Oppcomm')}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/opp_comms-history.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong className="top-text" style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>
                                                                {"Comms History".split(" ").map((word, i) => (
                                                                    <span key={i} className="top-word">
                                                                        {word}
                                                                    </span>
                                                                ))}
                                                            </strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5", padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/opp_comms-history.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong className="top-text" style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>
                                                                {"Comms History".split(" ").map((word, i) => (
                                                                    <span key={i} className="top-word">
                                                                        {word}
                                                                    </span>
                                                                ))}
                                                            </strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>
                                            <li className="nav-item">
                                                {assignedModules.has(MODULE_IDS.Quotations) && isLock.toString() === "0" ? (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-Opp-quotation' ? 'active' : ''}`} data-toggle="pill" href="#tab-Opp-quotation" onClick={() => changeTab('tab-Opp-quotation')}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/opp_quotations.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Quotations</strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5", padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/opp_quotations.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Quotations</strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>
                                            <li className="nav-item">
                                                {isLock.toString() === "0" ? (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-Opp-document' ? 'active' : ''}`} data-toggle="pill" href="#tab-Opp-document" onClick={() => changeTab('tab-Opp-document')}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/opp_documents.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Documents</strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5", padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/opp_documents.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Documents</strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>

                                        </ul>
                                        <div className="ml-auto">
                                            {activeTab === "tab-Oppurtunity" && (
                                                <HelpSite FormName="Opportunity Detail" Module="34" />
                                            )}
                                            {activeTab === "tab-Oppcomm" && (
                                                <HelpSite FormName="Communication History" Module="34" />
                                            )}
                                            {activeTab === "tab-Opp-quotation" && (
                                                <HelpSite FormName="Quotation" Module="34" />
                                            )}
                                            {activeTab === "tab-Opp-document" && (
                                                <HelpSite FormName="Documents" Module="34" />
                                            )}
                                            {activeTab === "tab-Opp-report" && (
                                                <HelpSite FormName="Report" Module="34" />
                                            )}
                                        </div>


                                    </div>

                                    <div className="col-sm-12 pl-0">
                                        <div className="tab-content p-3" id="v-pills-tabContent">
                                            <div className={`tab-pane fade ${activeTab === 'tab-Oppurtunity' ? 'show active' : ''}`} id="tab-Oppurtunity" role="tabpanel">
                                                <CreateOpportunityPage OpportunityID={parseInt(currentOpportunityID, 10)} onSuccess={handleSuccess} Tab={tabCount} onNext={onNext} onPrevious={onPrevious} isLock={isLock} onClose={onClose} IsCustomerSelection={parseInt(IsCustomerSelection, 10)} />
                                            </div>
                                            {currentOpportunityID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-Oppcomm' ? 'show active' : ''}`} id="tab-Oppcomm" role="tabpanel">
                                                    <CommunicationHistoryPage OpportunityID={parseInt(currentOpportunityID, 10)} Tab={tabCount} IsDiaries={IsDiaries} CommunicationID={CommunicationID} isLock={isLock} Phone={phone} Mobile={mobile} CompanyName={companyName} ToEmail={Email} />
                                                </div>
                                            )}
                                            {currentOpportunityID > 0 && assignedModules.has(MODULE_IDS.Quotations) && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-Opp-quotation' ? 'show active' : ''}`} id="tab-Opp-quotation" role="tabpanel">
                                                    <QuotationListPage ClientCompanyID={parseInt("0")} LeadID={parseInt("0")} OpportunityID={parseInt(currentOpportunityID, 10)} isLock={isLock} Tab={tabCount} />

                                                </div>
                                            )}
                                            {currentOpportunityID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-Opp-document' ? 'show active' : ''}`} id="tab-Opp-document" role="tabpanel">
                                                    <OpportunityDocumentListPage OpportunityID={parseInt(currentOpportunityID, 10)} isLock={isLock} Tab={tabCount} />
                                                </div>
                                            )}
                                            {currentOpportunityID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-Opp-udf' ? 'show active' : ''}`} id="tab-Opp-udf" role="tabpanel">
                                                    <OpportunityUserDefineFields OpportunityID={parseInt(currentOpportunityID, 10)} isLock={isLock} Tab={tabCount} />
                                                </div>
                                            )}
                                            {currentOpportunityID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-Opp-report' ? 'show active' : ''}`} id="tab-Opp-report" role="tabpanel">
                                                    <OpportunityReportPage OpportunityID={parseInt(currentOpportunityID, 10)} isLock={isLock} Tab={tabCount} />
                                                </div>
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </Draggable>
            </div>
        </div>
    );
}

export default OppurtunityDetail;
